import request from '@/utils/request';
import store from '@/store';
/**
 * 获取订单列表
 * @param params
 */
export function getOrderList(params) {
  return request({
    url: '/order/houseKeeper/orderHouseKeeperSearchList',
    method: 'get',
    params,
  });
}

/**
 * 获取订单详情
 * @param orderNo
 */
export function getOrderDetail(orderNo) {
  return request({
    url: '/order/houseKeeper/orderHouseKeeperDetail',
    method: 'get',
    params: { orderNo },
  });
}

// 查询订单是否可以无责取消
export function canCancel(data) {
  return request({
    url: '/order/houseKeeper/canCancel',
    method: 'get',
    params: data,
  });
}

// 取消直营订单
export function cancelOrderV2(data) {
  return request({
    url: '/order/houseKeeper/cancelOrderV2',
    method: 'post',
    data,
  });
}

// 获取临时密码
export function getTemporaryPassword(data) {
  return request({
    url: '/hardware/room/lock/relations/openDoor',
    method: 'post',
    data,
  });
}

// 获取住客待上传列表
export function getUploadList(data) {
  return request({
    url: '/order/houseKeeper/psbIdCardInfoList',
    method: 'get',
    params: data,
  });
}

// 完成住客信息上传
export function finishGuestUpload(data) {
  return request({
    url: '/order/houseKeeper/guestPsbCheckIn',
    method: 'get',
    params: data,
  });
}

// 下仔住客信息
export function downLoadGuestInfo(data) {
  return request({
    url: '/order/houseKeeper/downloadIdCardImage',
    method: 'get',
    params: data,
  });
}

// 赠送积分
export function directSendScore(data) {
  return request({
    url: '/order/houseKeeper/directSendScore',
    method: 'get',
    params: data,
  });
}

/**
 * 更新订单基础信息
 * @param data
 */
export function updateOrderBaseInfo(data) {
  return request({
    url: '/order/houseKeeper/orderEditData',
    method: 'post',
    data,
  });
}

/** 查询当前酒店是否开启统一预订V2。 */
export function getCommonBookGray() {
  return request({
    url: '/order/houseKeeper/orderBookingV2/commonBookGray',
    method: 'get',
  });
}

/** 新版统一预订提交入口。 */
export function commonBook(data) {
  return request({
    url: '/order/houseKeeper/orderBookingV2/commonBook',
    method: 'post',
    data,
  });
}

/**
 * 查询当前酒店是否开启新版修改订单
 */
export function getOrderEditV2Gray() {
  return request({
    url: '/order/houseKeeper/orderEditV2/gray',
    method: 'get',
  });
}

/**
 * 查询当前酒店是否开启轻赢宝渠道单操作灰度
 */
export function getQybChannelOrderActionGray() {
  return request({
    url: '/order/houseKeeper/orderOperationGray/qybChannelOrderAction',
    method: 'get',
  });
}

/**
 * 获取按房型平铺的新版修改订单数据
 * @param orderNo
 */
export function getOrderEditV2Detail(orderNo) {
  return request({
    url: '/order/houseKeeper/orderEditV2/detail',
    method: 'get',
    params: { orderNo },
  });
}

/**
 * 按完整房单目标态修改订单
 * @param data
 */
export function updateOrderV2(data) {
  return request({
    url: '/order/houseKeeper/orderEditV2/data',
    method: 'post',
    data,
  });
}
/**
 * 更新订单备注信息
 * @param data
 */
export function updateOrderReamark(data) {
  return request({
    url: '/order/houseKeeper/modifyOrderRemark',
    method: 'post',
    data,
  });
}
/**
 * 更新订单中房单价格日历
 * @param data
 */
export function updateOrdeLinkRoomPrice(data) {
  return request({
    url: '/order/houseKeeper/modifyOrderDayPrice',
    method: 'post',
    data,
  });
}
/**
 * 修改房单信息
 * @param data
 */
export function updateRoomOrderInfo(data) {
  return request({
    url: '/order/houseKeeper/modifyOrderRoom',
    method: 'post',
    data,
  });
}
/**
 * 更新订单中房单价格日历
 * @param data
 */
export function updateRoomOrderPrice(data) {
  return request({
    url: '/order/houseKeeper/modifyOrderRoomDayPrice',
    method: 'post',
    data,
  });
}
/**
 * 获取房单列表
 * @param params
 */
export function getOrderRoomList(params) {
  return request({
    url: '/order/houseKeeper/orderInfoRoomList',
    method: 'get',
    params,
  });
}

/**
 * 获取房单详情
 * @param orderNo
 */
export function getOrderRoomDetail(orderRoomNo) {
  return request({
    url: '/order/houseKeeper/orderRoomDetail',
    method: 'get',
    params: { orderRoomNo },
  });
}

/**
 * 获取房间最近已退房的房单号
 * @param {String} roomId 房间ID
 */
export function getLatestCheckedOutOrderRoomNo(roomId) {
  return request({
    url: '/order/houseKeeper/latestCheckedOutOrderRoomNo',
    method: 'get',
    params: { roomId },
  });
}

/**
 * 更新房单基础信息
 * @param data
 */
export function updateOrderRoomBaseInfo(data) {
  return request({
    url: '/order/houseKeeper/orderRoomRemark',
    method: 'post',
    data,
  });
}

/**
 * 获取房价日历
 * @param orderRoomNo
 */
export function getOrderRoomDayPrice(orderRoomNo) {
  return request({
    url: '/order/houseKeeper/getOrderRoomDayPrice',
    method: 'get',
    params: { orderRoomNo },
  });
}

/**
 * 添加入住人
 * @param data
 */
export function addRoomer(data) {
  const userShifts = store.getters.userShifts || {};
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeeperGuestSubmit',
    method: 'post',
    data: {
      ...data,
      classes: userShifts.name,
    },
  });
}

/**
 * 保存房单管家入住人信息
 * @param {Object} data - 要保存的入住人信息数据
 * @returns {Promise} - 返回一个包含请求结果的 Promise 对象
 */
export function orderRoomHouseKeeperGuestSave(data) {
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeeperGuestSave',
    method: 'post',
    data,
  });
}

/**
 * 修改入住人
 * @param data
 */
export function updateRoomer(data) {
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeeperGuestEdit',
    method: 'post',
    data,
  });
}

/**
 * 办理入住
 * @param data
 */
export function checkIn(data) {
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeeperGuestStaySubmit',
    method: 'post',
    data,
  });
}

/**
 * 房单排房/更换房间
 * @param data
 * notCheckRepeat 是否需要跳过重复请求校验
 */
export function arrangeRoomByRoomOrder(data, notCheckRepeat = false) {
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeepeCheckNumber',
    method: 'post',
    data,
    notCheckRepeat,
  });
}

/**
 * 取消排房
 * @param data
 */
export function cancelArrangeRoom(data) {
  return request({
    url: '/order/houseKeeper/orderRoomNumberCancel',
    method: 'get',
    params: data,
  });
}

/**
 * 取消订单
 * @param data
 */
export function cancelOrder(data) {
  return request({
    url: '/order/houseKeeper/cancelOrder',
    method: 'post',
    data,
  });
}

/**
 * 取消房单
 * @param data
 */
export function cancelOrderRoom(data) {
  return request({
    url: '/order/houseKeeper/cancelOrderRoom',
    method: 'post',
    data,
  });
}

/**
 * 获取取消原因
 */
export function getCancelReason() {
  return request({
    url: '/order/houseKeeper/getCancelReason',
    method: 'get',
  });
}
/**
 * 入住时校验时间
 */
export function stayInTimeCheck(data) {
  return request({
    url: '/order/houseKeeper/orderRoomStayCheck',
    method: 'post',
    data,
  });
}
/**
 * 房型升级
 */
export function orderRoomUpgrade(data) {
  return request({
    url: '/order/houseKeeper/orderRoomUpgrade',
    method: 'post',
    data,
  });
}
// /**
//  * 订单状态
//  * @returns {{list: *[]}}
//  */
// export function getOrderStatusOptions() {
//   return {
//     list: [
//       { code: '1', name: '待确认' },
//       { code: '2', name: '已拒绝' },
//       { code: '3', name: '已预订' },
//       { code: '4', name: '已取消' },
//       { code: '5', name: 'NoShow' },
//       { code: '6', name: '已完成' }
//     ]
//   }
// }
//
// /**
//  * 房单状态
//  * @returns {{list: *[]}}
//  */
// export function getRoomOrderStatusOptions() {
//   return {
//     list: [
//       { code: '0', name: '待入住' },
//       { code: '1', name: 'NoShow' },
//       { code: '2', name: '已入住' },
//       { code: '3', name: '已退房' },
//       { code: '4', name: '未结账' },
//       { code: '5', name: '已取消' }
//     ]
//   }
// }
/**
 * 获取取订单状态
 */
export function getOrderStatusOptions() {
  return request({
    url: '/order/houseKeeper/orderHotelKeeperStatusEnumList',
    method: 'get',
  });
}
/**
 * 获取取房单状态
 */
export function getRoomOrderStatusOptions() {
  return request({
    url: '/order/houseKeeper/orderRoomHotelKeeperStatusEnumList',
    method: 'get',
  });
}
/**
 * 重置密码
 */
export function resetPassword(params) {
  return request({
    url: '/order/houseKeeper/resetRoomPassWord',
    method: 'get',
    params,
  });
}
/**
 * 秘密吗置失效
 */
export function losePassword(params) {
  return request({
    url: '/order/houseKeeper/resetRoomPassWordIsValid',
    method: 'get',
    params,
  });
}
/**
 * 生成密码
 */
export function createPassword(params) {
  return request({
    url: '/order/houseKeeper/genereteRoomPassWord',
    method: 'get',
    params,
  });
}
/**
 * 自动排房
 */
export function autoArrangedRoom(params) {
  return request({
    url: '/order/houseKeeper/automaticArrangeRoom',
    method: 'post',
    data: params,
  });
}
/**
 * 查询批量排房列表o
 */
export function queryGroupOrderList(params) {
  return request({
    url: '/order/houseKeeper/queryBatchCheckIn',
    method: 'post',
    data: params,
  });
}
/**
 * 查询联房房单列表
 */
export function queryRelativeOrderList(params) {
  return request({
    url: '/order/houseKeeper/queryLinkRoom',
    method: 'get',
    params,
  });
}
/**
 * 批量添加入住人
 */
export function groupAddRoomer(params) {
  return request({
    url: '/order/houseKeeper/batchCheckIn',
    method: 'post',
    data: params,
  });
}
/**
 * 查询所有在住房间列表
 */
export function queryStayInRoomList(data) {
  return request({
    url: '/order/houseKeeper/queryOrderRoom',
    method: 'get',
    params: data,
  });
}
/**
 * 加入在住的联房
 */
export function joinRelativeRoomOrder(data) {
  return request({
    url: '/order/houseKeeper/buildLinkRoom',
    method: 'post',
    data,
  });
}
/**
 * 加入在住的团队
 */
export function joinGroupRelativeOrder(data) {
  return request({
    url: '/order/houseKeeper/joinTeamRoom',
    method: 'get',
    params: data,
  });
}
/**
 * 设为主单
 */
export function setMainOrder(data) {
  return request({
    url: '/order/houseKeeper/changeMasterOrderRoom',
    method: 'get',
    params: data,
  });
}
/**
 * 转出
 */
export function rollOutOrder(data) {
  return request({
    url: '/order/houseKeeper/rollOutOrderRoom',
    method: 'get',
    params: data,
  });
}
/**
 * 查询在住团队
 */
export function queryStayInGroupList(data) {
  return request({
    url: '/order/houseKeeper/queryTeamRoomList',
    method: 'get',
    params: data,
  });
}
/**
 * 查询在住团队
 */
export function queryRollInList(data) {
  return request({
    url: '/order/houseKeeper/queryTeamRoomList',
    method: 'get',
    params: data,
  });
}
/**
 * 转入联房
 */
export function rollIn(data) {
  return request({
    url: '/order/houseKeeper/rollInOrderRoom',
    method: 'post',
    data,
  });
}
/**
 * 减少同住
 */
export function minusRoomer(data) {
  return request({
    url: '/order/houseKeeper/orderRoomHouseKeeperGuestDecrease',
    method: 'post',
    data,
  });
}
/**
 * 钟点房转全日房二次确认
 */
export function switchToAllDayReConfirm(data) {
  return request({
    url: '/order/houseKeeper/secondConfirm',
    method: 'post',
    data,
  });
}
/**
 * 钟点房转全日房,取消排房并转全日房
 */
export function cancelAndTransHourToFullday(params) {
  return request({
    url: `/order/houseKeeper/cacelRoomNumberAndToFullDay`,
    method: 'get',
    params,
  });
}
/**
 * 钟点房转全日房
 */
export function switchToAllDay(data) {
  return request({
    url: '/order/houseKeeper/toFullDayOrder',
    method: 'post',
    data,
  });
}
// 恢复入住
export function returnToCheckIn(data) {
  return request({
    url: '/order/houseKeeper/returnToCheckIn',
    method: 'get',
    params: data,
  });
}
// 查询促销活动详情
export function getPromotionDetail(data) {
  return request({
    url: '/order/houseKeeper/promotions',
    method: 'get',
    params: data,
  });
}
// 当联房单只有一个房单时，解除联房
export function removeLinkRelative(data) {
  return request({
    url: '/order/houseKeeper/removeLinkRoom',
    method: 'get',
    params: data,
  });
}
// 超售接单
export function takeOrder(data) {
  return request({
    url: '/order/houseKeeper/acceptOrder',
    method: 'get',
    params: data,
  });
}
// 超售拒单
export function refuseOrder(data) {
  return request({
    url: '/order/houseKeeper/rejectOrder',
    method: 'get',
    params: data,
  });
}
// 入住登记单打印
export function stayInPrintToPdf(params, printType) {
  return request({
    url: '/system/pdf',
    method: 'post',
    data: params,
    printType,
    responseType: 'blob',
  });
}
// 钟点房修改预离时间
export function hourModifyTime(data) {
  return request({
    url: '/order/houseKeeper/hourModifyTime',
    method: 'post',
    data,
  });
}
// 查询是否有智能客控硬件
export function queryGuestHotelRoom(data) {
  return request({
    url: '/hardware/guest/queryGuestHotelRoom',
    method: 'post',
    data,
  });
}
// 人脸信息验证
export function uploadFaceInfo(data) {
  return request({
    url: '/order/houseKeeper/uploadFaceInfo',
    method: 'post',
    data,
  });
}
// 批量校验房态
export function groupCheckRoomStutas(data) {
  return request({
    url: '/order/houseKeeper/batchArrangeRoomCheck',
    method: 'post',
    data,
  });
}

// 发送密码的弹窗页面 增加一个查看密码
export function queryLockPassWord(data) {
  return request({
    url: '/hardware/room/lock/relations/queryLockPassWord',
    method: 'get',
    params: data,
  });
}

// 发送密码的弹窗页面 增加一个查看密码
export function getUserPhone(data) {
  return request({
    url: '/order/houseKeeper/getVirtualPhone',
    method: 'get',
    params: data,
  });
}

export function modifyOrderInfoRoomBreakfast(data) {
  return request({
    url: '/order/houseKeeper/modifyOrderInfoRoomBreakfast',
    method: 'post',
    data,
  });
}

// 全日房加收房费可选列表
export function getFullDayAddRoomFeeRuleList(data) {
  return request({
    url: '/order/web/account/room/getNeedAddRoomFee',
    method: 'get',
    params: data,
  });
}

/**
 * 续住单原单操作取消续住
 */
export function cancelOrderRoomContinueStayChange(data) {
  return request({
    url: '/order/houseKeeper/cancelOrderRoomContinueStayChange',
    method: 'post',
    data,
  });
}

/**
 * 标记订单为NoShow
 */
export function markNoShow(data) {
  return request({
    url: '/order/houseKeeper/markNoshow',
    method: 'post',
    data,
  });
}

/**
 * 查询异常订单列表
 */
export function queryOrderAbnormal(params) {
  return request({
    url: '/order/queryOrderAbnormal',
    method: 'get',
    params,
  });
}

/**
 * 异常订单一键接单
 */
export function quickCreateOrder(data) {
  return request({
    url: '/order/quickCreateOrder',
    method: 'post',
    data,
  });
}
